import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import StandartPage from '../Layouts/Shared/_StandartPage';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Row, Col, Label, Input, ListGroup, ListGroupItem, FormGroup } from 'reactstrap';
import { InputMask } from 'primereact/inputmask';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import 'ckeditor5/ckeditor5.css';
import defaultProfile2 from '../Assets/Images/profile/defaultProfile2.jpg';
import CompCrmSegmentDropdown from '../Components/Common/CompCrmSegmentDropdown';
import CompCrmCountryDropdown from '../Components/Common/CompCrmCountryDropdown';
import CompCrmCityDropdown from '../Components/Common/CompCrmCityDropdown';
import CompCrmDistrictDropdown from '../Components/Common/CompCrmDistrictDropdown';
import CompDtCashDesk from '../Components/Crm/CompDtCashDesk';
import CompDtOrder from '../Components/Crm/CompDtOrder';
import CompDtCrmAccountStatement from '../Components/Crm/CompDtCrmAccountStatement';
import CompCrmAccessSettings from '../Components/Crm/CompCrmAccessSettings';
import CompDtCrmAddressInformation from '../Components/Crm/CompDtCrmAddressInformation';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import CompLoaderDt from '../Components/Common/CompLoaderDt';

export default function Customer() {

    const navigate = useNavigate();
    const params = useParams();
    let crmId = params.crmId;
    let tabId = params.tabId;
    const [tabIndex, setTabIndex] = useState(0);

    const [modalCreateCashDesk, setModalCreateCashDesk] = useState(false);
    const toggleModalCreateCashDesk = () => setModalCreateCashDesk(!modalCreateCashDesk);

    useEffect(() => {

        switch (tabId) {
            case "baseInformation": setTabIndex(0); break;
            case "accessSettings": setTabIndex(1); break;
            case "addressInformation": setTabIndex(2); break;
            case "bankAccountInformation": setTabIndex(3); break;
            case "crmAccountStatement": setTabIndex(4); break;
            case "order": setTabIndex(5); break;
            default:
                navigate('/crm/' + crmId + '/baseInformation');
                break;
        }

    }, [tabId, crmId, navigate]);

    const { t } = useTranslation();
    const [displayName, setDisplayName] = useState(false);
    const [dataLocked, setDataLocked] = useState(true);
    const [seed, setSeed] = useState(0);
    const [logged, setLogged] = useState(false);
    const [dataMyCrmDetails, setDataMyCrmDetails] = useState(null);
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    useEffect(() => {
        console.log(crmId);
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            setDisplayName(JSON.parse(currentSession)?.displayName);
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.get(ApiGateway + '/crm/crm/' + crmId + '/find-and-get')
                .then(response => {
                    setDataMyCrmDetails(response.data?.payload);
                    setLogged(true);
                    /*axios.get(ApiGateway + '/market-place/trader/my-cash-desk/list')
                        .then(thenResponse => {
                            setDataMyCrmBankAccountsDetails(thenResponse.data?.payload);
                        })
                        .catch(thenError => {
                            console.error(thenError);
                        });
                    */
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t, crmId]);

    const [selectedItemSegment, setSelectedItemSegment] = useState('-1');
    const [segmentPersonalBlock, setSegmentPersonalBlock] = useState('d-none');
    const [segmentCompanyBlock, setSegmentCompanyBlock] = useState('d-none');
    const [formRemainIsShow, setFormRemainIsShow] = useState('d-none');
    const [title, setTitle] = useState('');

    const [contactName, setContactName] = useState('');
    const [contactSurname, setContactSurname] = useState('');
    const [contactBirthDate, setContactBirthDate] = useState('');
    const [contactIdentityNumber, setContactIdentityNumber] = useState('');
    const [contactIdentityValidation, setContactIdentityValidation] = useState(false);
    const [emailSendingAllowed, setEmailSendingAllowed] = useState(false);
    const [smsSendingAllowed, setSmsSendingAllowed] = useState(false);

    const [legalCompanyTitle, setLegalCompanyTitle] = useState('');
    const [taxOffice, setTaxOffice] = useState('');
    const [taxNumber, setTaxNumber] = useState('');

    const [note, setNote] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber,] = useState('');
    const [mobileNumber, setMobileNumber,] = useState('');
    const [selectedItemCountry, setSelectedItemCountry] = useState('-1');
    const [selectedItemCity, setSelectedItemCity] = useState('-1');
    const [selectedItemDistrict, setSelectedItemDistrict] = useState('-1');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');

    const onChangeCompCrmSegmentDropdown = (data) => {
        if (data?.includes("RETAIL_")) {
            setSegmentCompanyBlock('d-none');
            setSegmentPersonalBlock('mb-3');
            setFormRemainIsShow('mb-3');
        } else if (data?.includes("COMMERCIAL_")) {
            setSegmentPersonalBlock('d-none');
            setSegmentCompanyBlock('mb-3');
            setFormRemainIsShow('mb-3');
        } else {
            setSegmentCompanyBlock('d-none');
            setSegmentPersonalBlock('d-none');
            setFormRemainIsShow('d-none');
        }
        setSelectedItemSegment(data);
    }

    const onChangeCompCrmCountryDropdown = (data) => {
        setSelectedItemCountry(data);
        setSelectedItemCity(-1);
        setSelectedItemDistrict(-1);
    }

    const onChangeCompCrmCityDropdown = (data) => {
        setSelectedItemCity(data);
        setSelectedItemDistrict(-1);
    }

    const onChangeCompCrmDistrictDropdown = (data) => {
        setSelectedItemDistrict(data);
    }

    useEffect(() => {
        if (dataMyCrmDetails !== undefined && dataMyCrmDetails !== null) {
            let message = t('product.common-notification.loaded');
            let formattedBirthDate = "";
            if (dataMyCrmDetails?.segment?.value?.includes("RETAIL_") && dataMyCrmDetails?.contactBirthDate != null) {
                formattedBirthDate = moment(dataMyCrmDetails?.contactBirthDate).format('DD.MM.YYYY');
            }
            onChangeCompCrmSegmentDropdown(dataMyCrmDetails?.segment?.value);
            setContactName(dataMyCrmDetails?.contactName);
            setContactSurname(dataMyCrmDetails?.contactSurname);
            setContactBirthDate(formattedBirthDate);
            setContactIdentityNumber(dataMyCrmDetails?.contactIdentityNumber);
            setContactIdentityValidation(dataMyCrmDetails?.contactIdentityValidation);
            setLegalCompanyTitle(dataMyCrmDetails?.legalCompanyTitle);
            setTaxOffice(dataMyCrmDetails?.taxOffice);
            setTaxNumber(dataMyCrmDetails?.taxNumber);
            setTitle(dataMyCrmDetails?.title);
            setSelectedItemCountry(dataMyCrmDetails?.district?.city?.country?.id);
            setSelectedItemCity(dataMyCrmDetails?.district?.city?.id);
            setSelectedItemDistrict(dataMyCrmDetails?.district?.id);
            setAddress(dataMyCrmDetails?.address);
            setZipCode(dataMyCrmDetails?.zipCode);
            setPhoneNumber(dataMyCrmDetails?.phoneNumber);
            setMobileNumber(dataMyCrmDetails?.mobileNumber);
            setEmail(dataMyCrmDetails?.email);
            setEmailSendingAllowed(dataMyCrmDetails?.emailSendingAllowed);
            setSmsSendingAllowed(dataMyCrmDetails?.smsSendingAllowed);
            if (dataMyCrmDetails?.note !== undefined && dataMyCrmDetails?.note !== null) {
                setNote(dataMyCrmDetails?.note);
            }
        }
    }, [t, logged, dataMyCrmDetails]);

    return (
        <StandartPage title={t('pages.crm.title')} >
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="col-12 p-2 container">
                        <React.Fragment>
                            <ToastContainer />
                            {dataMyCrmDetails ? ((
                                <Row>
                                    <Col className={"col-md-2"}>
                                        <img src={defaultProfile2} width={200} height={200} title="Default User Profile" alt="Default User Profile" />
                                        <h4>{t('pages.crm.left-side.my-crm-details')}</h4>
                                        <h5>{title}</h5>
                                    </Col>
                                    <Col className={"col-md-10"}>
                                        <Tabs defaultIndex={tabIndex} onSelect={(index) => console.log('changed tab to => ' + index)}>
                                            <TabList>
                                                <Tab>{t('pages.crm.tabs.base-information')}</Tab>
                                                <Tab>{t('pages.crm.tabs.access-settings')}</Tab>
                                                <Tab>{t('pages.crm.tabs.address-information')}</Tab>
                                                <Tab>{t('pages.crm.tabs.account-information')}</Tab>
                                                <Tab>{t('pages.crm.tabs.crm-account-statement')}</Tab>
                                                <Tab>{t('pages.crm.tabs.order')}</Tab>
                                            </TabList>
                                            <TabPanel>
                                                <Row className="mt-3 mb-3">
                                                    <Col className={"col-md-6"}>
                                                        <Label className="form-label">{t('pages.crm.form.label.segment')}</Label>
                                                        <CompCrmSegmentDropdown seedValue={seed} onChange={onChangeCompCrmSegmentDropdown} selectedOption={selectedItemSegment} isDisabled={dataLocked} />
                                                    </Col>
                                                </Row>
                                                <Row className={segmentPersonalBlock}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.contact-first-name')}</Label>
                                                        <Input type="text" className="form-control" disabled={dataLocked}
                                                            onChange={(e) => setContactName(e.target.value)} onKeyUp={(e) => setContactName(e.target.value)} value={contactName}
                                                            placeholder={t('pages.crm.form.placeholder.contact-first-name')} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.contact-last-name')}</Label>
                                                        <Input type="text" className="form-control" disabled={dataLocked}
                                                            onChange={(e) => setContactSurname(e.target.value)} onKeyUp={(e) => setContactSurname(e.target.value)} value={contactSurname}
                                                            placeholder={t('pages.crm.form.placeholder.contact-last-name')} />
                                                    </Col>
                                                </Row>
                                                <Row className={segmentPersonalBlock}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.contact-identity-number')}</Label>
                                                        <InputMask id="contactIdentityNumber" className={"form-control"} disabled={dataLocked} mask="99999999999" placeholder={t('pages.crm.form.placeholder.contact-identity-number')} onChange={e => setContactIdentityNumber(e.target.value)} onKeyUp={e => setContactIdentityNumber(e.target.value)} value={contactIdentityNumber} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.contact-birth-date')}</Label>
                                                        <InputMask id="contactBirthDate" className={"form-control"} disabled={dataLocked} mask="99.99.9999" placeholder={t('pages.crm.form.placeholder.contact-birth-date')} onChange={e => setContactBirthDate(e.target.value)} onKeyUp={e => setContactBirthDate(e.target.value)} value={contactBirthDate} />
                                                    </Col>
                                                </Row>
                                                <Row className={segmentPersonalBlock}>
                                                    <Col className={"col-md-6"}>
                                                        <Label className="form-label">{t('pages.crm.form.label.identity-verification-status')}</Label>
                                                    </Col>
                                                    <Col className={"col-md-6"}>
                                                        <div className={contactIdentityValidation === true ? "d-none" : "hstack gap-2 justify-content-end"}>

                                                            <span >
                                                                <span className='text-danger'><CloseCircleOutlined /></span> {t('pages.crm.form.label.identity-verification-status.unverified')}
                                                            </span>                                                       </div>
                                                        <div className={contactIdentityValidation === true ? "hstack gap-2 justify-content-end" : "d-none"}>
                                                            <span >
                                                                <span className='text-success'><CheckCircleOutlined /></span> {t('pages.crm.form.label.identity-verification-status.verified')}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className={segmentCompanyBlock}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.legal-company-title')}</Label>
                                                        <Input type="text" className="form-control" disabled={dataLocked}
                                                            onChange={(e) => setLegalCompanyTitle(e.target.value)} onKeyUp={(e) => setLegalCompanyTitle(e.target.value)} value={legalCompanyTitle}
                                                            placeholder={t('pages.crm.form.placeholder.legal-company-title')} />
                                                    </Col>
                                                    <Col lg={6}>

                                                    </Col>
                                                </Row>
                                                <Row className={segmentCompanyBlock}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.tax-office')}</Label>
                                                        <Input type="text" className="form-control"
                                                            onChange={(e) => setTaxOffice(e.target.value)} onKeyUp={(e) => setTaxOffice(e.target.value)} value={taxOffice} disabled={dataLocked}
                                                            placeholder={t('pages.crm.form.placeholder.tax-office')} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.tax-number')}</Label>
                                                        <Input type="text" className="form-control"
                                                            onChange={(e) => setTaxNumber(e.target.value)} onKeyUp={(e) => setTaxNumber(e.target.value)} value={taxNumber} disabled={dataLocked}
                                                            placeholder={t('pages.crm.form.placeholder.tax-number')} />
                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.country')}</Label>
                                                        <CompCrmCountryDropdown key={seed} onChange={onChangeCompCrmCountryDropdown} selectedOption={selectedItemCountry} isDisabled={dataLocked} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label htmlFor="choices-status-input" className="form-label">{t('pages.crm.form.label.city')}</Label>
                                                        <CompCrmCityDropdown key={seed} onChange={onChangeCompCrmCityDropdown} cascadeOption={selectedItemCountry} selectedOption={selectedItemCity} isDisabled={dataLocked} />
                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={6}>
                                                        <Label htmlFor="datepicker-deadline-input" className="form-label">{t('pages.crm.form.label.district')}</Label>
                                                        <CompCrmDistrictDropdown key={seed} onChange={onChangeCompCrmDistrictDropdown} cascadeOption={selectedItemCity} selectedOption={selectedItemDistrict} isDisabled={dataLocked} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label htmlFor="datepicker-deadline-input" className="form-label">{t('pages.crm.form.label.zip-code')}</Label>
                                                        <Input type="text" className="form-control" disabled={dataLocked}
                                                            onChange={(e) => setZipCode(e.target.value)} onKeyUp={(e) => setZipCode(e.target.value)} defaultValue={zipCode}
                                                            placeholder={t('pages.crm.form.placeholder.zip-code')} />
                                                    </Col>

                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={12}>
                                                        <Label className="form-label">{t('pages.crm.form.label.address')}</Label>
                                                        <Input type="textarea" className="form-control" rows={1} disabled={dataLocked}
                                                            onChange={(e) => setAddress(e.target.value)} onKeyUp={(e) => setAddress(e.target.value)} defaultValue={address}
                                                            placeholder={t('pages.crm.form.placeholder.address')} />
                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.mobile-number')}</Label>
                                                        <InputMask id="mobileNumber" className={"form-control"} mask="(599) 999-9999" placeholder={t('pages.crm.form.placeholder.mobile-number')} onChange={e => setMobileNumber(e.target.value)} onKeyUp={e => setMobileNumber(e.target.value)} value={mobileNumber} disabled={dataLocked} />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Label className="form-label">{t('pages.crm.form.label.phone-number')}</Label>
                                                        <InputMask id="phoneNumber" className={"form-control"} mask="(999) 999-9999" placeholder={t('pages.crm.form.placeholder.phone-number')} onChange={e => setPhoneNumber(e.target.value)} onKeyUp={e => setPhoneNumber(e.target.value)} value={phoneNumber} disabled={dataLocked} />
                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={6}>
                                                        <Label htmlFor="choices-status-input" className="form-label">{t('pages.crm.form.label.email')}</Label>
                                                        <Input type="text" className="form-control"
                                                            onChange={(e) => setEmail(e.target.value)} onKeyUp={(e) => setEmail(e.target.value)} defaultValue={email} disabled={dataLocked}
                                                            placeholder={t('pages.crm.form.placeholder.email')} />
                                                    </Col>
                                                    <Col lg={6}>

                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className={formRemainIsShow}>
                                                        <Label className="form-label " style={{}}>{t('pages.crm.form.label.notification-settings')}</Label>
                                                        <ListGroup style={{}}>
                                                            <ListGroupItem style={{}}>
                                                                <Row>
                                                                    <Col lg={1}>
                                                                        <div className="mb-3 mb-lg-0">
                                                                            <div className="mb-0">
                                                                                <FormGroup switch>
                                                                                    <Input
                                                                                        type="switch"
                                                                                        checked={smsSendingAllowed}
                                                                                        disabled={dataLocked}
                                                                                    />
                                                                                </FormGroup>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={11}>
                                                                        <h6 style={{ fontWeight: 'bold' }}>{t('pages.crm.form.label.notification-settings.sms')}</h6>
                                                                        {t('pages.crm.form.label.notification-settings.sms-description')}
                                                                    </Col>
                                                                </Row>
                                                            </ListGroupItem>
                                                            <ListGroupItem style={{}}>
                                                                <Row>
                                                                    <Col lg={1}>
                                                                        <div className="mb-3 mb-lg-0">
                                                                            <div className="mb-0">
                                                                                <FormGroup switch>
                                                                                    <Input
                                                                                        type="switch"
                                                                                        checked={emailSendingAllowed}
                                                                                        disabled={dataLocked}
                                                                                    />
                                                                                </FormGroup>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={11}>
                                                                        <h6 style={{ fontWeight: 'bold' }}>{t('pages.crm.form.label.notification-settings.email')}</h6>
                                                                        {t('pages.crm.form.label.notification-settings.email-description')}
                                                                    </Col>
                                                                </Row>
                                                            </ListGroupItem>
                                                        </ListGroup>
                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col lg={6}>

                                                    </Col>
                                                    <Col lg={6}>

                                                    </Col>
                                                </Row>
                                                <Row className={formRemainIsShow}>
                                                    <Col className={"col-md-9"}>

                                                    </Col>
                                                    <Col className={"col-md-3"}>
                                                        <div className="hstack gap-2 justify-content-end">

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                            <TabPanel>
                                                <CompCrmAccessSettings />
                                            </TabPanel>
                                            <TabPanel>
                                                <CompDtCrmAddressInformation />
                                            </TabPanel>
                                            <TabPanel>
                                                <Row>
                                                    <Col className={"col-md-12"}>
                                                        <CompDtCashDesk />
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                            <TabPanel>
                                                <Row>
                                                    <Col className={"col-md-12"}>
                                                        <CompDtCrmAccountStatement />
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                            <TabPanel>
                                                <Row>
                                                    <Col className={"col-md-12"}>
                                                        <CompDtOrder />
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                        </Tabs>
                                    </Col>
                                </Row>
                            )) : (
                                <Row>
                                    <Col className={"col-md-12 text-center"}>
                                        <CompLoaderDt />
                                    </Col>
                                </Row>
                            )}

                        </React.Fragment>
                    </Col>
                </Row>
            </React.Fragment>
        </StandartPage>
    )

}